import axios from 'axios';

const papi = axios.create({ baseURL: '/api' });

papi.interceptors.request.use((config) => {
  const token = localStorage.getItem('parceiro_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

papi.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('parceiro_token');
      if (window.location.pathname.startsWith('/parceiro') && !window.location.pathname.includes('/login')) {
        window.location.href = '/parceiro/login';
      }
    }
    return Promise.reject(error);
  }
);

export const portalApi = {
  login: (email, password) => papi.post('/portal/auth/login', { email, password }),
  me: () => papi.get('/portal/auth/me'),
  alterarSenha: (senha_atual, nova_senha) => papi.post('/portal/auth/alterar-senha', { senha_atual, nova_senha }),
  dashboard: () => papi.get('/portal/dashboard'),
  listImoveis: () => papi.get('/portal/imoveis'),
  createImovel: (data) => papi.post('/portal/imoveis', data),
  updateImovel: (id, data) => papi.put(`/portal/imoveis/${id}`, data),
  listSolicitacoes: (filtro = 'todas', busca = '') => papi.get('/portal/solicitacoes', { params: { filtro, busca } }),
  getSolicitacao: (id) => papi.get(`/portal/solicitacoes/${id}`),
  createSolicitacao: (data) => papi.post('/portal/solicitacoes', data),
  aprovar: (id) => papi.post(`/portal/solicitacoes/${id}/aprovar`),
  pagamentoAntecipado: (id) => papi.post(`/portal/solicitacoes/${id}/pagamento-antecipado`),
  limite: () => papi.get('/portal/limite'),
  solicitarAumento: (valor_solicitado, motivo) => papi.post('/portal/limite/solicitar-aumento', { valor_solicitado, motivo }),
  faturas: () => papi.get('/portal/faturas'),
  pixFatura: (fid) => papi.post(`/portal/faturas/${fid}/pix`),
  confirmarPagamento: (fid) => papi.post(`/portal/faturas/${fid}/confirmar-pagamento`),
  faturaPdf: (fid) => papi.get(`/portal/faturas/${fid}/pdf`, { responseType: 'blob' }),
  upload: (files) => {
    const fd = new FormData();
    files.forEach((f) => fd.append('files', f));
    return papi.post('/portal/uploads', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  publicServicos: () => papi.get('/public/servicos'),
  publicCidades: () => papi.get('/public/cidades-atendimento'),
};

export default papi;
